import { IncidentRef } from "@/components/inputs/IncidentsInput";

export interface InvestigationForm {
  name: string;
  description: string;
  details: string;
  status: string;
  lead_investigator_id: string | null;
  incident_type_id: string | null;
  incidents: IncidentRef[];
  findings: string;
  recommendations: string;
}

export interface InvestigationPayload {
  investigation: InvestigationForm;
}
